module.exports = __webpack_public_path__ + "img/logo_header.b73ca3b6.svg";